module.exports = __webpack_public_path__ + "static/media/icon-negocios.80d14133.svg";